import React, { FC, useState } from 'react'
import Burger from './Burger'
import Footer from './Footer'
import AdaptiveHeader from './Header/AdaptiveHeader'
import Header from './Header/Header'

const DefaultLayout = (props) => {
    const [showBurger, setShowBurger] = useState(false)

    return (
        <div className="wrapper">
            <AdaptiveHeader set={setShowBurger} />
            <Header />
            <Burger set={setShowBurger} show={showBurger} />
            <div>{props.children}</div>
            <Footer />
        </div>
    )
}

export default DefaultLayout
